import(/* webpackMode: "eager" */ "/home/ubuntu/connectory-gitlab/connectory-web/src/app/page.tsx");
